import React from 'react';
import QueueStatus from '../../components/callcenter/QueueStatus';

const CallcenterQueueStatusPage = () => {
  return <QueueStatus />;
};

export default CallcenterQueueStatusPage;

